import { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { UL } from '@expo/html-elements';
import { theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsTabLinksNav = (props: Props) => {
  const { children } = props;

  return <UL style={styles.container}>{children}</UL>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing['8'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren;
